module.exports = __webpack_public_path__ + "static/media/student skill average.b376c405.svg";